import xhr from 'xhr';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

var qs = require('qs');

dayjs.extend(utc);
dayjs.extend(timezone);

/** Debe coincidir con `ACTIVITIES_ASKS_PENDING_
 * WINDOW_DAYS` en klazia-api (teacher.js). */
const TEACHER_PENDING_CUTOFF_DAYS = 90;

export function getTeacherPendingListCutoffIso() {
  return new Date(Date.now() - TEACHER_PENDING_CUTOFF_DAYS * 864e5).toISOString();
}

/*
 * La IA publica cada hora de 7:00 a 21:00, entre 8 y 12 h después del envío (lo de la noche sale
 * a más tardar a las 9:00): ninguna entrega espera más de ~20 h. Si una entrega con IA sigue sin
 * nota pasado este plazo, la IA no la publicó y pasa al docente. Debe coincidir con
 * AI_TEACHER_FALLBACK_HOURS en klazia-api (teacher.js).
 */
const AI_TEACHER_FALLBACK_HOURS = 24;

export function getTeacherAiFallbackCutoffIso() {
  return dayjs().subtract(AI_TEACHER_FALLBACK_HOURS, 'hour').toISOString();
}

function pendingAskOrSittingCount(val) {
  if (typeof val === 'number') return val;
  return Array.isArray(val) ? val.length : 0;
}

export default async function getCounts({ user, programType }) {
  const base = `/teachers/${user.teacher.id}/${user.id}/data`;
  const url = programType ? `${base}?${qs.stringify({ program_type: programType })}` : base;
  const res = await xhr(url);
  const data = res?.data?.data ?? res?.data ?? res ?? {};
  const questions = data.questions || [];
  const activities = data.activities || [];
  const messages = data.messages || [];

  const sumAsks = questions.reduce((acc, obj) => acc + pendingAskOrSittingCount(obj.asksCount), 0);
  const sumActivities = activities.reduce(
    (acc, obj) => acc + pendingAskOrSittingCount(obj.sittingsCount),
    0
  );
  const chatMessages =
    data.messagesCount !== undefined ? data.messagesCount : (messages?.length ?? 0);

  return {
    asks: sumAsks,
    activities: sumActivities,
    chatMessages,
    asksData: questions,
    activitiesData: activities,
    chatMessagesData: messages,
  };
}
